import { useState } from 'react';
import { CodeStep } from './steps/CodeStep/CodeStep';
import { InitializeStep } from './steps/InitializeStep/InitializeStep';
import { PasswordResetStep } from './steps/PasswordResetStep/PasswordResetStep';
import { SuccessStep } from './steps/SuccessStep/SuccessStep';

type Step = 'initialize' | 'code' | 'passwordReset' | 'success';

export const ForgotPasswordSteps = () => {
  const [currentStep, setCurrentStep] = useState<Step>('initialize');
  const [username, setUsername] = useState<string>('');
  const [code, setCode] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [codeErrorMessage, setCodeErrorMessage] = useState<string | undefined>();

  const goToCodeStep = () => {
    setCurrentStep('code');
  };

  const goToPasswordResetStep = () => {
    setCodeErrorMessage(undefined);
    setCurrentStep('passwordReset');
  };

  const handlePasswordResetError = (errorMessage?: string) => {
    setCodeErrorMessage(errorMessage);
    setCurrentStep('code');
  };

  const steps = {
    initialize: <InitializeStep goToNextStep={goToCodeStep} setUsername={setUsername} />,
    code: (
      <CodeStep
        goToNextStep={goToPasswordResetStep}
        goToPreviousStep={() => setCurrentStep('initialize')}
        username={username}
        setCode={setCode}
        errorMessage={codeErrorMessage}
      />
    ),
    passwordReset: (
      <PasswordResetStep
        goToNextStep={() => setCurrentStep('success')}
        goToPreviousStep={handlePasswordResetError}
        username={username}
        code={code}
        persistPassword={setPassword}
        persistedPassword={password}
      />
    ),
    success: <SuccessStep />,
  };

  const currentStepComponent = steps[currentStep];

  return <div>{currentStepComponent}</div>;
};
